var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.167 7.1665V7.1665C12.3007 7.1665 9.86748 7.1665 8.32278 8.63719C8.25957 8.69736 8.19785 8.75908 8.13767 8.82229C6.66699 10.367 6.66699 12.8002 6.66699 17.6665V23.1665C6.66699 24.4236 6.66699 25.0521 7.05752 25.4426C7.44804 25.8332 8.07658 25.8332 9.33366 25.8332H14.8337C19.7 25.8332 22.1332 25.8332 23.6779 24.3625C23.7411 24.3023 23.8028 24.2406 23.863 24.1774C25.3337 22.6327 25.3337 20.1995 25.3337 15.3332V15.3332",
    stroke: "#1C1B1F",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 13.8333L20 13.8333",
    stroke: "#222222",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 19.1667H16",
    stroke: "#222222",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.333 11.1665L25.333 3.1665M21.333 7.1665H29.333",
    stroke: "#222222",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateMessage);
export default __webpack_public_path__ + "static/media/createMessage.d34264cf077eaa7532499db1f57d9855.svg";
export { ForwardRef as ReactComponent };